export const TOOlTIP_FIELDS = {
  qaSpecificationStatus: {
    fieldPath: 'qaSpecification.status',
  },
  // allergens
  allergenIsPresent: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.isPresent',
  },

  allergenTypeCode: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.allergenTypeCode',
  },

  levelOfContainmentCode: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.levelOfContainmentCode',
  },
  containmentSource: {
    fieldPath:
      'qaSpecification.allergens.allergenRelatedInformation.allergen.containmentSource',
  },
  // Formula Fields
  formulaActiveIngredients: {
    fieldPath: 'qaSpecification.formula.activeIngredients',
  },
  formulaInactiveIngredients: {
    fieldPath: 'qaSpecification.formula.inactiveIngredients',
  },
  formulaIngredientsPurposeStrength: {
    fieldPath: 'qaSpecification.formula.ingredientsPurposeStrength',
  },
  formulaOtherIngredients: {
    fieldPath: 'qaSpecification.formula.otherIngredients',
  },
  formulaProductClaims: {
    fieldPath: 'qaSpecification.formula.productClaims',
  },
  formulaFreeFrom: {
    fieldPath: 'qaSpecification.formula.freeFrom',
  },
  formulaIngredientDefinitions: {
    fieldPath: 'qaSpecification.formula.ingredientDefinitions',
  },
  formulaEpaRegistrationNumber: {
    fieldPath: 'qaSpecification.formula.epaRegistrationNumber',
  },
  formulaFormula: {
    fieldPath: 'qaSpecification.formula.formula',
  },
  // Formula Grid Columns
  formulaSalesDesignation: {
    fieldPath: 'qaSpecification.formula.formula.salesDesignation',
  },
  formulaTechnicalDesignation: {
    fieldPath: 'qaSpecification.formula.formula.technicalDesignation',
  },
  formulaCasNumber: {
    fieldPath: 'qaSpecification.formula.formula.casNumber',
  },
  formulaCountry: {
    fieldPath: 'qaSpecification.formula.formula.country',
  },
  formulaFunction: {
    fieldPath: 'qaSpecification.formula.formula.function',
  },
  formulaClassificationAndRiskPhrases: {
    fieldPath: 'qaSpecification.formula.formula.classificationAndRiskPhrases',
  },
  formulaOrigin: {
    fieldPath: 'qaSpecification.formula.formula.origin',
  },
  formulaOriginSpecification: {
    fieldPath: 'qaSpecification.formula.formula.originSpecification',
  },
  formulaPercentOfRawMaterialSubstance: {
    fieldPath: 'qaSpecification.formula.formula.percentOfRawMaterialSubstance',
  },
  formulaPercentOfIncorporatedRawMaterial: {
    fieldPath:
      'qaSpecification.formula.formula.percentOfIncorporatedRawMaterial',
  },
  formulaPercentOfFinishedProductSubstance: {
    fieldPath:
      'qaSpecification.formula.formula.percentOfFinishedProductSubstance',
  },
  formulaDocuments: {
    fieldPath: 'qaSpecification.formula.formula.documents',
  },
  // certificate
  certificateStatus: {
    fieldPath: 'qaSpecification.certificates.status',
  },
  type: {
    fieldPath: 'qaSpecification.certificates.type',
  },
  documentName: {
    fieldPath: 'qaSpecification.certificates.documentName',
  },
   // qa spec template documents
  qaSpecTemplateDocumentName: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.documentName',
  },
  qaSpecTemplateAssetType: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.assetType',
  },
  qaSpecTemplateFileExtension: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.fileExtension',
  },
  qaSpecTemplateFileSize: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.fileSize',
  },
  qaSpecTemplateUploadDate: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.uploadDate',
  },
   qaSpecTemplateDownloadDate: {
    fieldPath: 'qaSpecification.qaSpecTemplateDocuments.downloadDate',
  },
  // fine art
  finalArtDocumentName: {
    fieldPath: 'qaSpecification.certificate.finalArtDocumentName',
  },
  finalArtJobId: {
    fieldPath: 'qaSpecification.certificate.finalArtJobId',
  },
  finalArtUploadDate: {
    fieldPath: 'qaSpecification.certificate.finalArtUploadDate',
  },
  finalArtDocumentName: {
    fieldPath: 'qaSpecification.certificate.finalArtDocumentName',
  },
  finalArtSKUName: {
    fieldPath: 'qaSpecification.certificate.finalArtSKUName',
  },
  finalArtUploadDate: {
    fieldPath: 'qaSpecification.certificate.finalArtUploadDate',
  },
  certificateName: {
    fieldPath: 'qaSpecification.certificates.certificateName',
  },
  certificateSubType: {
    fieldPath: 'qaSpecification.certificates.subtype',
  },
  certificateBody: {
    fieldPath: 'qaSpecification.certificates.certificateBody',
  },
  certificateExpiryDate: {
    fieldPath: 'qaSpecification.certificates.expirationDate',
  },
  characteristicType: {
    fieldPath: 'qaSpecification.certificates.characteristicType',
  },
  certificateFileType: {
    fieldPath: 'qaSpecification.certificates.fileType',
  },

  certificateUploadDate: {
    fieldPath: 'qaSpecification.certificates.uploadDate',
  },

  certificateLevel: {
    fieldPath: 'qaSpecification.certificates.level',
  },
  certificateType: {
    fieldPath: 'qaSpecification.certificates.type',
  },
  certificateExpirationDate: {
    fieldPath: 'qaSpecification.certificates.expirationDate',
  },
  internalFilePath: {
    fieldPath: 'qaSpecification.certificates.internalFilePath',
  },
  internalFileName: {
    fieldPath: 'qaSpecification.certificates.internalFileName',
  },
  originalFileName: {
    fieldPath: 'qaSpecification.certificates.originalFileName',
  },
  fileExtension: {
    fieldPath: 'qaSpecification.certificates.fileExtension',
  },
  certificateFileSize: {
    fieldPath: 'qaSpecification.certificates.fileSize',
  },

  // contact
  contactType: {
    fieldPath: 'qaSpecification.contacts.type',
  },
  contactAssociatedRetailers: {
    fieldPath: 'qaSpecification.contacts.associatedretailers',
  },
  contactDepartment: {
    fieldPath: 'qaSpecification.contacts.department',
  },
  contactFirstName: {
    fieldPath: 'qaSpecification.contacts.firstName',
  },
  contactLastName: {
    fieldPath: 'qaSpecification.contacts.lastName',
  },
  contactEmail: {
    fieldPath: 'qaSpecification.contacts.email',
  },
  contactAlternativeEmails: {
    fieldPath: 'qaSpecification.contacts.alternativeEmails',
  },
  contactPhoneNumber: {
    fieldPath: 'qaSpecification.contacts.phoneNumber',
  },
  contactDescription: {
    fieldPath: 'qaSpecification.contacts.description',
  },
  contactStatus: {
    fieldPath: 'qaSpecification.contacts.status',
  },
  contactAddress: {
    fieldPath: 'qaSpecification.contacts.address',
  },
  contactCountry: {
    fieldPath: 'qaSpecification.contacts.country',
  },
  contactState: {
    fieldPath: 'qaSpecification.contacts.state',
  },
  contactCity: {
    fieldPath: 'qaSpecification.contacts.city',
  },
  contactZipCode: {
    fieldPath: 'qaSpecification.contacts.zipCode',
  },

  //location
  locationType: {
    fieldPath: 'qaSpecification.locations.type',
  },
  locationAddress: {
    fieldPath: 'qaSpecification.locations.address',
  },
  locationCity: {
    fieldPath: 'qaSpecification.locations.city',
  },
  locationState: {
    fieldPath: 'qaSpecification.locations.state',
  },
  locationCountry: {
    fieldPath: 'qaSpecification.locations.country',
  },
  locationZipCode: {
    fieldPath: 'qaSpecification.locations.zipCode',
  },
  locationPhoneNumber: {
    fieldPath: 'qaSpecification.locations.phoneNumber',
  },
  locationMobileNumber: {
    fieldPath: 'qaSpecification.locations.mobileNumber',
  },
  locationFaxNumber: {
    fieldPath: 'qaSpecification.locations.faxNumber',
  },
  locationEmail: {
    fieldPath: 'qaSpecification.locations.email',
  },
  locationName: {
    fieldPath: 'qaSpecification.locations.locationName',
  },
  locationDescription: {
    fieldPath: 'qaSpecification.locations.locationDescription',
  },
  locationStatus: { fieldPath: 'qaSpecification.locations.status' },

  productSpecificationCertificateBadge: {
    fieldPath: 'qaSpecification.productSpecification.certificateBadge',
  },
  productSpecificationSupportingDocument: {
    fieldPath: 'qaSpecification.productSpecification.supportingDocument',
  },
  labelType: {
    fieldPath: 'qaSpecification.factPanels.nutritionalInformation.labelType',
  },
  ingredientNotice: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.ingredientNotice',
  },
  nutritionFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.fdaLabelFootNote',
  },
  factPanelsLanguageCode: {
    fieldPath: 'qaSpecification.factPanels.nutritionalInformation.languageCode',
  },
  servingsPerContainer: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.servingsPerContainer',
  },
  //Nutrient Form Specific Fields
  nutritionTypeCode: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.nutritionTypeCode',
  },
  measurementPrecisionCode: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.measurementPrecision',
  },
  dailyValueIntakePercent: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.dailyValueIntakePercent',
  },
  quantity: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.quantity',
  },
  quantityUom: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.quantityUom',
  },
  dailyValuePrecision: {
    fieldPath:
      'qaSpecification.factPanels.nutritionalInformation.nutritionDetails.dailyValuePrecision',
  },
  // Supplement Information Specific Fields
  supplementTypeCode: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.supplementTypeCode',
  },
  supplementUnitOfMeasure: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.unitOfMeasure',
  },
  // Added Supplement Information Fields
  supplementServingSize: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.servingSize',
  },
  supplementServingSizeMeasurement: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingSizeMeasurement',
  },
  supplementServingSizeDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingSizeDescription',
  },
  supplementServingPerContainerDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.servingPerContainerDescriptor',
  },
  supplementNumberOfServingsPerContainer: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.numberOfServingsPerContainer',
  },
  supplementCalories: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.calories',
  },
  supplementCaloriesFromFat: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.caloriesFromFat',
  },
  supplementFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.fdaLabelFootNote',
  },
  supplementOtherIngredients: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.otherIngredients',
  },
  supplementLanguageCode: {
    fieldPath: 'qaSpecification.factPanels.supplementInformation.languageCode',
  },
  // Nutrients
  nutrientNutritionName: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.nutritionName',
  },
  nutrientIngredientsPartOf: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.ingredientsPartOf',
  },
  nutrientDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.descriptor',
  },
  nutrientQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityPrecision',
  },
  nutrientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantity',
  },
  nutrientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityUom',
  },
  nutrientQuantityDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.quantityDescription',
  },
  nutrientDailyValue: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailyValue',
  },
  supplementDailyValuePrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailyValuePrecision',
  },
  nutrientDailySymbol: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.dailySymbol',
  },
  nutrientItalicNutrient: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.italicNutrient',
  },
  nutrientItalicDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.nutrients.italicDescriptor',
  },
  // Dietary Ingredients
  dietaryIngredientName: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.ingredientName',
  },
  dietaryIngredientsPartOf: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.ingredientsPartOf',
  },
  dietaryDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.descriptor',
  },
  dietaryQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityPrecision',
  },
  dietaryQuantity: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantity',
  },
  dietaryQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityUom',
  },
  dietaryQuantityDescription: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.quantityDescription',
  },
  dietaryDailySymbol: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.dailySymbol',
  },
  dietaryItalicDietary: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.italicDietary',
  },
  dietaryItalicDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.supplementInformation.dietaryIngredients.italicDescriptor',
  },
  // Drug facts
  drugFactLabelType: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.labelType',
  },
  drugFactAgeGroup: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.directions.ageGroup',
  },
  drugFactDirectionDosage: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.directions.directionDosage',
  },
  drugFactUses: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.uses.useText',
  },
  drugFactUseDetail: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.uses.useDetail',
  },
  drugFactDosageUnit: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.dosageUnit',
  },
  // Active Ingredients
  activeIngredientName: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.ingredientName',
  },
  activeIngredientPurposeDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.purposeDescriptor',
  },
  activeIngredientQuantityPrecision: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantityPrecision',
  },
  activeIngredientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantity',
  },
  activeIngredientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.quantityUom',
  },
  activeIngredientItalicName: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.italicName',
  },
  activeIngredientItalicPurposeDescriptor: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.activeIngredients.italicPurposeDescriptor',
  },
  // Inactive Ingredients
  inactiveIngredients: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.inactiveIngredients',
  },
  warningText: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.warnings.warningText',
  },
  warningDetail: {
    fieldPath:
      'qaSpecification.factPanels.drugInformation.warnings.warningDetail',
  },
  boldText: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.warnings.boldText',
  },
  boldDetail: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.warnings.boldDetail',
  },
  otherInformation: {
    fieldPath: 'qaSpecification.factPanels.drugInformation.otherInformation',
  },
  // Pet Food
  petNutritionLabelType: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.labelType',
  },
  petNutritionMeasurementPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.measurementPerCup',
  },
  petNutritionMeasurementUomPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.measurementUomPerCup',
  },
  petNutritionCalorieContent: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.calorieContent',
  },
  petNutritionCaloriesPerCup: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.caloriesPerCup',
  },
  petNutritionProtein: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.protein',
  },
  petNutritionFat: {
    fieldPath: 'qaSpecification.factPanels.petNutritionalInformation.fat',
  },
  petNutritionCarbohydrate: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.carbohydrate',
  },
  petNutritionFdaLabelFootNote: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.fdaLabelFootNote',
  },
  petNutritionEnzymesAndMicroorganisms: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.enzymesAndMicroorganisms',
  },
  petNutritionNutritionalAdequacyStatement: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutritionalAdequacyStatement',
  },
  // Pet Nutrition Nutrients
  petNutrientName: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.nutrientName',
  },
  petNutrientLimit: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.limit',
  },
  petNutrientGuaranteed: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.guaranteed',
  },
  petNutrientGuaranteedUom: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.guaranteedUom',
  },
  petNutrientQuantity: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.quantity',
  },
  petNutrientQuantityUom: {
    fieldPath:
      'qaSpecification.factPanels.petNutritionalInformation.nutrients.quantityUom',
  },

  // components
  caS_INCI_HSCode: {
    fieldPath: 'qaSpecification.components.components.caS_INCI_HSCode',
  },
  component: {
    fieldPath: 'qaSpecification.components.components.component',
  },
  componentsCountryOfOrigin: {
    fieldPath:
      'qaSpecification.components.components.componentsCountryOfOrigin',
  },
  componentsFunction: {
    fieldPath: 'qaSpecification.components.components.componentsFunction',
  },
  componentsPartOf: {
    fieldPath: 'qaSpecification.components.components.componentsPartOf',
  },
  manufacturer: {
    fieldPath: 'qaSpecification.components.components.manufacturer',
  },
  quantityInPercent: {
    fieldPath: 'qaSpecification.components.components.quantityInPercent',
  },
  totalWeight: {
    fieldPath: 'qaSpecification.components.components.totalWeight',
  },
  productClaims: {
    fieldPath: 'qaSpecification.components.productClaims',
  },

  // labeling
  isoCertifier: {
    fieldPath: 'qaSpecification.labeling.isoCertifier',
  },
  isoyn: {
    fieldPath: 'qaSpecification.labeling.isoyn',
  },
  kosherCertifier: {
    fieldPath: 'qaSpecification.labeling.kosherCertifier',
  },
  kosherYN: {
    fieldPath: 'qaSpecification.labeling.kosherYN',
  },
  halalYN: {
    fieldPath: 'qaSpecification.productSpecification.halalYN',
  },
  halalCertifier: {
    fieldPath: 'qaSpecification.labeling.halalCertifier',
  },
  nonGMOCertifier: {
    fieldPath: 'qaSpecification.labeling.nonGMOCertifier',
  },
  nonGMOYN: {
    fieldPath: 'qaSpecification.labeling.nonGMOYN',
  },
  organicCertifier: {
    fieldPath: 'qaSpecification.labeling.organicCertifier',
  },
  organicYN: {
    fieldPath: 'qaSpecification.labeling.organicYN',
  },
  brcCertifier: {
    fieldPath: 'qaSpecification.labeling.brcCertifier',
  },
  ifsCertifier: {
    fieldPath: 'qaSpecification.labeling.ifsCertifier',
  },
};
